import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import * as z from 'zod'
import { viewerModel } from '~/entities/common/viewer'
import { User } from '~/shared/api'
import { Option, OptionEnum } from '~/shared/config/constants'
import { TimezoneCode } from '~/shared/config/enums'

export type FormValues = Omit<
  z.infer<typeof User.schema>,
  'regionsIds' | 'rolesIds' | 'timezone'
> & {
  regionsIds: UniqueId[] | Option[]
  rolesIds?: UniqueId[] | Option[]
  timezone: TimezoneCode | OptionEnum<TimezoneCode> | null
}

export const Gate = createGate()

export const domain = createDomain('features.user.personalData')

sample({
  clock: Gate.open,
  target: viewerModel.userRequested,
})
